<template>
    <div class="favourites" @click.stop="toggleFav" v-if="showFavouritesOnIcon">
        <i class="sport-icon lb-sport sporticon-favourites" :class="iconClass"></i>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'FavouriteToggle',
    props: {
        match: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        ...mapActions('favourites', [
            'addFavourite',
            'removeFavourite',
        ]),
        toggleFav()
        {
            if (!this.isFavourite)
            {
                this.addFavourite(this.match);
                this.$emit('favouritetoggled', true);
            }
            else
            {
                this.removeFavourite(this.match);
                this.$emit('favouritetoggled', false);
            }
        },
    },
    computed: {
        ...mapGetters('favourites', [
            'getFavourites',
            'showFavouritesOnIcon',
        ]),
        isFavourite()
        {
            return this.getFavourites.find((favMatch) => favMatch.matchId.toString() === this.match.matchId.toString());
        },
        iconClass()
        {
            return {
                active: this.isFavourite,
                'sporticon-favouritesactive': this.isFavourite,
            };
        },
    },
};
</script>
